import axios from "axios";
import { getCookie } from "./cookies";

export const axiosHttpClien = (info) => {
    return new Promise(function (resolve, reject) {
        axios({
            url: info.url,
            method: info.method,
            headers: info.headers,
            data: info.data,
        })
            .then((result) => {
                if (info.type && info.type === "graphql") {
                    let obj = { ...result.data.data };
                    if (result.data?.errors) {
                        obj = { ...obj, errors: result.data.errors };
                    }
                    return resolve(obj);
                } else {
                    return resolve(result.data);
                }
            })
            .catch((error) => {
                return reject(error);
            });
    });
};

export const samlLogout = async () => {
    try {
        const apiInfo = {
            url: `${process.env.REACT_APP_BASE_URL}/saml/logout`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: "",
        };

        await axiosHttpClien(apiInfo);
        return true;
    } catch (error) {
        return false;
    }
};

export const createDateTime = (date, time) => {
    let publishedDateTime = new Date();
    if (date && time) {
        publishedDateTime = new Date(date);

        publishedDateTime.setDate(date.getDate());
        publishedDateTime.setMonth(date.getMonth());
        publishedDateTime.setFullYear(date.getFullYear());

        publishedDateTime.setHours(time.getHours());
        publishedDateTime.setMinutes(time.getMinutes());
        publishedDateTime.setSeconds(time.getSeconds());
    }
    return publishedDateTime;
};

export const graphQLAxiosClient = (params) => {
    const variables = { ...params.body };
    const jwt = getCookie("piap_jwt_token");
    const url = process.env.REACT_APP_API_HOST;
    const apiInfo = {
        url,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt}`,
        },
        data: {
            query: params.query,
            variables,
        },
        type: params.type,
    };

    return axiosHttpClien(apiInfo);
};

export const axiosAction = async (apiInfo) => {
    const response = await axios({
        url: apiInfo.url,
        method: apiInfo.method,
        headers: apiInfo.headers,
        data: apiInfo.data,
    });

    if (apiInfo.type === "graphql") {
        const obj = { ...response.data.data, errors: response.data.errors };
        return obj;
    } else {
        return response;
    }
};
